<div class="d-flex justify-content-between mt-5">
  <h2 class="headline-32 mb-0">{{ 'onboarding.welcomeTo' | translate }}</h2>
  <i
    class="fa-solid fa-circle-xmark pointer fa-2x"
    (click)="closeModal()"
  ></i>
</div>
<img
  class="img-fluid w-75"
  [src]="logo"
  alt="stazzle Logo"
/>
<div
  class="alert-info alert"
  *ngIf="isMobileDevice && isFirstTimeLogin"
>
  <h6 class="fw-bold">{{ 'mobileDeviceNote.headText' | translate }}</h6>
  <span [innerHTML]="'mobileDeviceNote.bodyText' | translate"></span>
</div>
<p
  class="mb-4"
  [innerHTML]="'onboarding.introduction' | translate: { applicationName: application.toLowerCase() }"
></p>
<a
  href="https://hub.stazzle.de/business-medical/self-onboarding"
  target="_blank"
>
  <img
    class="rounded-3 pointer my-2 w-100"
    src="assets-global/images/onboarding/self-onboarding.svg"
  />
</a>
<h1 class="headline-20 mt-4">{{ 'onboarding.todosTitle' | translate }}</h1>
<hr class="bg-lightest-gray my-4" />
<ng-container *ngFor="let todo of todos; let i = index">
  <h3 class="headline-16 mb-3">{{ todo.title | translate }}</h3>
  <div class="row">
    <div
      class="col-lg-6"
      [ngClass]="{ 'order-lg-2': i % 2 !== 0 }"
    >
      <img
        [src]="'assets-global/images/onboarding/' + todo.image"
        [alt]="todo.title | translate"
        class="img-fluid mb-4 mb-lg-0"
      />
    </div>
    <div
      class="col-lg-6"
      [ngClass]="{ 'order-lg-1': i % 2 === 0 }"
    >
      <p class="mb-6">{{ todo.text | translate }}</p>
      <base-button
        class="mb-4"
        color="primary"
        [size]="buttonSize.md"
        [routerLink]="todo.buttonLink"
        [label]="todo.buttonText"
        (click)="modalRef.close()"
      ></base-button>
    </div>
  </div>
  <hr
    class="bg-lightest-gray"
    *ngIf="i !== todos.length - 1"
  />
</ng-container>
